export enum VideoState {
  NeverConnected = 'neverConnected',
  UnsupportedBrowser = 'unsupportedBrowser',
  Connecting = 'connecting',
  Connected = 'connected',
  Paused = 'paused',
  Disconnected = 'disconnected',
  Failed = 'failed',
  Closed = 'closed',
  ReplacedByAnotherDevice = 'replacedByAnotherDevice'
}
